import React from 'react'
import moment from 'moment'
import clsx from 'classnames'
import styles from './VisitInfo.module.scss'

type DateInfoProps = {
  date: string,
  time: string,
  icon?: React.ReactNode,
  className?: string,
}

/** «12 марта, 14:00» line of a visit */
export const DateInfo: React.FC<DateInfoProps> = ({ date, time, icon, className }) => (
  <div className={clsx([styles.info, className])}>
    {icon && <div className={styles.icon}>
      {icon}
    </div>}
    <div className={styles.dateContainer}>
      <div className={styles.date}>{moment(date).format('D MMMM')}</div>
      <div className={styles.time}>{time}</div>
    </div>
  </div>
)
